'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _styledComponents2.default.span.withConfig({
  componentId: 's1obkf6a-0'
})(['display:inline-block;width:calc(', ' / 1.5);height:calc(', ' / 1.5);margin-left:calc(', ' / 1.5);&::after{content:\'\';display:block;width:60%;height:100%;border-bottom:2px solid ', ';border-right:2px solid ', ';transform:rotate(45deg) translateY(-4px);transform:rotate(45deg) translateY(-4px);opacity:0;}', ''], function (p) {
  return p.theme.spacingUnit;
}, function (p) {
  return p.theme.spacingUnit;
}, function (p) {
  return p.theme.spacingUnit;
}, function (p) {
  return p.theme.successColor;
}, function (p) {
  return p.theme.successColor;
}, function (p) {
  return p.success && '\n    &::after {\n      opacity: 1;\n    }\n  ';
});